(function($) {
    var documentLoad = function() {
        $('.column-module > div').matchHeight();

        // Used to make sure the WP Google Maps renders
        window.dispatchEvent(new Event('resize'));
    };
    $(window).on('load', documentLoad);
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/shortcodes/column-module.js